import AppTitle from '@theme/components/atom/AppTitle'

export default {
  name: 'PageIntro',
  components: {
    AppTitle,
  },
  props: {
    title: String,
    content: String,
    background: String,
    backgroundMobile: String,
  },
  computed: {
    backgroundStyle() {
      return this.background ? { backgroundImage: `url(${this.background}) !important` } : {}
    },
  },
}
